import { Flex, Text } from '@chakra-ui/react';
import { faFile } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonText } from '@morressier/alembic';
import { ISubmissionFile } from '@publishing-engine/domain/models';
import { openFile } from 'src/utils/file';

export const AuthorResponseAttachments = ({
  authorResponseAttachments
}: {
  authorResponseAttachments?: ISubmissionFile[];
}) =>
  !!authorResponseAttachments?.length && (
    <Flex flexDirection="column" gap={2}>
      <Text textStyle="headingItem">Attached Files</Text>
      {authorResponseAttachments.map(attachment => (
        <Flex justifyContent="space-between" key={attachment.referenceName}>
          <Flex gap={3} alignItems="center" marginStart={1}>
            <FontAwesomeIcon icon={faFile} />
            <Text
              textStyle="textBody"
              textAlign={'initial'}
              wordBreak={'break-word'}
              whiteSpace={'normal'}
            >
              {attachment.referenceName}
            </Text>
            <ButtonText onClick={() => openFile(attachment.url)}>
              View
            </ButtonText>
          </Flex>
        </Flex>
      ))}
    </Flex>
  );
